import { NavLink } from 'react-router-dom';
import { saveSelectedImageState } from './useImageNavigationState';

const ImageDetailNav = ({
    previousImage,
    nextImage,
    navigationImages
}) => {
    const createNavigationState = (image) => ({ image, navigationImages });

    const handleNavigationClick = (event, image) => {
        if (!image) {
            event.preventDefault();
            return;
        }

        saveSelectedImageState(createNavigationState(image));
    };

    return (
        <div className="image-detail-nav">
            <NavLink
                className={`image-detail-nav-button ${previousImage ? '' : 'disabled'}`}
                to={previousImage ? `/images/${previousImage.id}/` : '#'}
                state={previousImage ? createNavigationState(previousImage) : undefined}
                aria-disabled={!previousImage}
                onClick={(event) => handleNavigationClick(event, previousImage)}
            >
                Previous image
            </NavLink>

            <NavLink
                className={`image-detail-nav-button ${nextImage ? '' : 'disabled'}`}
                to={nextImage ? `/images/${nextImage.id}/` : '#'}
                state={nextImage ? createNavigationState(nextImage) : undefined}
                aria-disabled={!nextImage}
                onClick={(event) => handleNavigationClick(event, nextImage)}
            >
                Next image
            </NavLink>
        </div>
    );
};

export default ImageDetailNav;
